import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {combineLatest, identity, Observable, of, zip} from 'rxjs';
import {AuthorizationService} from '../../authorization/authorization.service';
import {catchError, map, switchMap, take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BankTransactionService {

  public static readonly FINISHED = 'finished';
  public static readonly HOLD_CONFIRMED = 'hold-confirmed';
  public static readonly REFUND = 'refund';
  public static readonly INSURANCE_PAYMENT_TO_ANOTHER_ACQUIRER = 'insurance-payment-to-another-acquirer';
  public static readonly REGULAR_PAYMENT = 'regular-payment';
  public static readonly HOLDING = 'holding';
  public static readonly BALANCE_PACKAGE_PURCHASE = 'balance-package-purchase';
  public static readonly SUBSCRIPTION_PURCHASE = 'subscription-purchase';

  constructor(
    protected http: HttpClient,
    protected translate: TranslateService,
    protected authorizationService: AuthorizationService,
    @Inject('ENVIRONMENT_VERSION') protected environmentVersion,
    @Inject('ENVIRONMENT_API_BASEPOINT') protected environmentApiBasepoint
  ) { }

  canRefundTransaction(transactionProcess: string, transactionStatus: string): Observable<boolean> {
    return combineLatest(
      this.authorizationService.loggedInUserHasRightsNonLessThanSuperuser(),
      this.authorizationService.getEntityAccessRights()
    ).pipe(
      take(1),
      map(
        ([hasRightsOfSuperuser, userAccessRights]) => {
          if (!userAccessRights['end-user-order-transaction'] || !userAccessRights['end-user-order-transaction'].update) {
            return false;
          }
          if (
            transactionStatus !== 'confirmed'
            && transactionStatus !== BankTransactionService.FINISHED
            && transactionStatus !== BankTransactionService.HOLD_CONFIRMED
          ) {
            return false;
          }
          if (
            transactionProcess === BankTransactionService.REGULAR_PAYMENT
            || transactionProcess === BankTransactionService.HOLDING
            || transactionProcess === BankTransactionService.BALANCE_PACKAGE_PURCHASE
            || transactionProcess === BankTransactionService.SUBSCRIPTION_PURCHASE
          ) {
            return true;
          }
          if (transactionProcess === BankTransactionService.INSURANCE_PAYMENT_TO_ANOTHER_ACQUIRER && hasRightsOfSuperuser) {
            return true;
          }
          return false;
        }
      )
    );
  }

  refundTransaction(transactionId): Observable<any> {
    return this.http
      .patch(
        this.environmentApiBasepoint + 'end-user-order-transaction/' + transactionId,
        {actionType: 'refund'},
        {observe: 'body'}
      );
  }

  refundTransfer(transferId): Observable<boolean> {
    return this.http
      .post<{success: boolean}>(
        this.environmentApiBasepoint + 'transfer-refund',
        {end_user_order_transaction_transfer_id: transferId},
        {observe: 'body'}
      ).pipe(
        catchError((error: HttpErrorResponse) => of({success: false})),
        map(
          responseBody => responseBody.success
        )
      );
  }
}
